module.exports = __webpack_public_path__ + "static/media/scheduled.fb484f4c.svg";